import React from 'react';
import './ELVSection.scss';

const ELVSection = ({ fields }) => {
  return (
    <section className="howItWorkSection">
      <div className="container customContainer">
        <div className="mainHeading">
          <p>{fields?.ELVHeading?.value || ''}</p>
          <h2>{fields?.ELVSubheading?.value || ''}</h2>
        </div>

        <div className="innerContainer">
          <div className="workOuter">
            <div className="workboxInner">
              <div className="workBox imgWrapCircle">
                <img
                  src={fields?.Image1?.value?.src || ''}
                  alt="Choose Vehicle"
                  className="img-responsive"
                />
              </div>
              <div className="line"></div>
            </div>
            <p>{fields?.Image1Text?.value || ''}</p>
          </div>

          <div className="workOuter">
            <div className="workboxInner">
              <div className="workBox imgWrapCircle">
                <img
                  src={fields?.Image2?.value?.src || ''}
                  alt="Configure EMI"
                  className="img-responsive"
                />
              </div>
              <div className="line"></div>
            </div>
            <p>{fields?.Image2Text?.value || ''}</p>
          </div>

          <div className="workOuter">
            <div className="workboxInner">
              <div className="workBox imgWrapCircle">
                <img
                  src={fields?.Image3?.value?.src || ''}
                  alt="Verify Terms"
                  className="img-responsive"
                />
              </div>
              <div className="line"></div>
            </div>
            <p>{fields?.Image3Text?.value || ''}</p>
          </div>

          <div className="workOuter">
            <div className="workboxInner">
              <div className="workBox imgWrapCircle">
                <img
                  src={fields?.Image4?.value?.src || ''}
                  alt="Share Application"
                  className="img-responsive"
                />
              </div>
            </div>
            <p>{fields?.Image4Text?.value || ''}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ELVSection;
